import React from "react"
import { useTranslation } from "@3nvi/gatsby-theme-intl"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import ForkArmsLayout from "../components/fork-arms-layout"

const Construction = ({data}) => {
  const { t } = useTranslation()
  return (
    <Layout>

        <ForkArmsLayout
            LHImage={data.lhimage.childImageSharp.gatsbyImageData}
            LHText={data.lhtext.childMarkdownRemark.html}
            RHImage={data.rhimage.childImageSharp.gatsbyImageData}
            RHText={data.rhtext.childMarkdownRemark.html}
            Stamps={data.stamps.nodes}
            PDFs={data.downloads.nodes}
            title={t("construction.image-title")}
            stampText={t("construction.stamp-text")}
        ></ForkArmsLayout>

    </Layout>
  )
}

export default Construction

export const pageQuery = graphql`

query($lang: String) {

  downloads: allFile(
    filter: { relativeDirectory: {eq: "fork-arms"}, sourceInstanceName: {eq: $lang}, extension: {eq: "pdf"} }
  ) {
    nodes {
      publicURL
      name
    }
  }

  stamps: allFile(
    filter: { relativeDirectory: {eq: "fork-arms/stamps"}, sourceInstanceName: {eq: $lang}, extension: {eq: "jpeg"} }
  ) {
    nodes {
        id
        childImageSharp {
          gatsbyImageData 
        }   
    }
  }

  lhimage: file(sourceInstanceName: {eq: $lang}, name: {eq: "construction-lh"}) {
    id
      childImageSharp {
        gatsbyImageData (
            layout: FULL_WIDTH
        )
      }   
  }

  rhimage: file(sourceInstanceName: {eq: $lang}, name: {eq: "construction-rh"}) {
    id
      childImageSharp {
        gatsbyImageData (
            layout: CONSTRAINED
        )
      }   
  }

  lhtext: file(sourceInstanceName: {eq: $lang}, name: {eq: "construction-lh-text"}) {
    id
      childMarkdownRemark {
        html
      }
  }

  rhtext: file(sourceInstanceName: {eq: $lang}, name: {eq: "construction-rh-text"}) {
    id
      childMarkdownRemark {
        html
      }
  }

}

`;